import React, { useState, Fragment, useEffect } from "react";
import { Col, Container, Row, Image } from "react-bootstrap";
import Filter from "./Filter";
import { UPDATE_SELECTED_CATEGORY_TAB } from "../../../../store/types";
import { useDispatch } from "react-redux";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import { Toggle } from "../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import moment from "moment";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";

import Typography from "@material-ui/core/Typography";

import { OrdersRequestInsideList } from "./OrdersRequestInsideList";

import EditPageAddItemRightBody from "./EditPageAddItemRightBody";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddButton from "./AddButton";
import isEmpty from "../../../../store/validation/is-Empty";
import { Hidden } from "@material-ui/core";
import CustomerEditModel from "./CustomerEditModel";
import Media from "react-media";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";

// const data = [
//   {
//     title: "Specials",
//     data: [
//       {
//         id: 0,
//         image: require("../../../../assets/images/Orders/charles-D-vDQMTfAAU-unsplash.png"),
//         rating: "4.2",
//         best: false,
//         vegtype: 0,
//         title: "Veg Mushroom Momos",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//       {
//         id: 1,
//         image: require("../../../../assets/images/Orders/charles-D-vDQMTfAAU-unsplash.png"),
//         rating: "3.2",
//         best: true,
//         vegtype: 1,
//         title: "Chicken Momos",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//       {
//         id: 2,
//         image: require("../../../../assets/images/Orders/Mask Group 113.png"),
//         rating: "3.4",
//         best: true,
//         vegtype: 0,
//         title: "Veg Mushroom Momos",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//       {
//         id: 3,
//         image: require("../../../../assets/images/Orders/charles-D-vDQMTfAAU-unsplash.png"),
//         rating: "1.2",
//         best: false,
//         vegtype: 0,
//         title: "Mexican Wave Pizza",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//       {
//         id: 4,
//         image: require("../../../../assets/images/Orders/Mask Group 113.png"),
//         rating: "2.2",
//         best: true,
//         vegtype: 0,
//         title: "Veg Mushroom Momos",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//     ],
//     sub: false,
//     subdata: [],
//   },
//   {
//     title: "Starters",
//     sub: false,
//     subdata: [],
//     data: [
//       {
//         id: 0,
//         image: require("../../../../assets/images/Orders/charles-D-vDQMTfAAU-unsplash.png"),
//         rating: "4.2",
//         best: false,
//         vegtype: 0,
//         title: "Veg Mushroom Momos",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//       {
//         id: 1,
//         image: require("../../../../assets/images/Orders/Mask Group 113.png"),
//         rating: "3.2",
//         best: true,
//         vegtype: 1,
//         title: "Chicken Momos",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//       {
//         id: 2,
//         image: require("../../../../assets/images/Orders/charles-D-vDQMTfAAU-unsplash.png"),
//         rating: "3.4",
//         best: true,
//         vegtype: 0,
//         title: "Veg Mushroom Momos",
//         price: "450",
//         ptime: "40-50 mins",
//         servers: 2,
//         atime: "11:00 AM",
//         ftype: "Halal",
//         cal: "500 Cal",
//       },
//     ],
//   },
//   {
//     title: "Momos",
//     data: [],
//     sub: true,
//     subdata: [
//       {
//         id: 0,
//         title: "Veg Momos",
//         data: [
//           {
//             id: 0,
//             image: require("../../../../assets/images/Orders/charles-D-vDQMTfAAU-unsplash.png"),
//             rating: "4.2",
//             best: false,
//             vegtype: 0,
//             title: "Veg Mushroom Momos",
//             price: "450",
//             ptime: "40-50 mins",
//             servers: 2,
//             atime: "11:00 AM",
//             ftype: "Halal",
//             cal: "500 Cal",
//           },
//           {
//             id: 1,
//             image: require("../../../../assets/images/Orders/Mask Group 113.png"),
//             rating: "3.2",
//             best: true,
//             vegtype: 1,
//             title: "Chicken Momos",
//             price: "450",
//             ptime: "40-50 mins",
//             servers: 2,
//             atime: "11:00 AM",
//             ftype: "Halal",
//             cal: "500 Cal",
//           },
//           {
//             id: 2,
//             image: require("../../../../assets/images/Orders/charles-D-vDQMTfAAU-unsplash.png"),
//             rating: "3.4",
//             best: true,
//             vegtype: 0,
//             title: "Veg Mushroom Momos",
//             price: "450",
//             ptime: "40-50 mins",
//             servers: 2,
//             atime: "11:00 AM",
//             ftype: "Halal",
//             cal: "500 Cal",
//           },
//         ],
//         sub: false,
//         subdata: [],
//       },
//     ],
//   },
// ];

// Hook
export function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
const EditPageOrderRequestBody = (props) => {
  const size = useWindowSize();
  const [state, setState] = useState({
    search: "",
    count: 1,
    dispType: 0,
    cart: 1,
  });
  const dispatch = useDispatch();
  const onSearchChange = (e) => {
    setState({ ...state, search: e.target.value });
  };
  const decrementHandler = (e) => {
    if (state.count !== 0) {
      setState({ ...state, cart: state.cart - 1 });
    }
  };

  const incrementHandler = (e) => {
    setState({ ...state, cart: state.cart + 1 });
  };
  const updateCart = (e) => {
    setState({ ...state, cart: state.cart + 1 });
  };

  const [showVeg, setShowVeg] = useState(false);

  const [hideSoldOut, setHideSoldOut] = useState(false);

  const { count, cart } = state;

  const onChangeTab = (id) => {
    //setSelectedTabId(id);
    dispatch({ type: UPDATE_SELECTED_CATEGORY_TAB, payload: id });
  };
  const [data, setData] = useState([]);
  const [categories, setCats] = useState([]);

  useEffect(() => {
    if (props.selectedTabId === 1) {
      setData(props.data);
    } else {
      let filterCategory = props.data.filter((item) => {
        return item._id === props.selectedTabId;
      });
      setData(filterCategory);
    }
  }, [props.data, props.selectedTabId]);

  useEffect(() => {
    setCats(props.data);
  }, []);

  const [showdefault, setDefault] = useState(true);
  useEffect(() => {
    if (size.width < 991) {
      setDefault(false);
    } else {
      setDefault(true);
    }
  }, [size.width]);
  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          {(size.width < 991 && !showdefault) || size.width >= 991 ? (
            <Col md={9} lg={9} xs={12}>
              <Container fluid style={{ padding: "0" }}>
                <Media query="(max-width: 992px)">
                  <CustomerEditModel
                    top={true}
                    cart={cart}
                    payment={props.payment}
                    data={categories}
                  />
                </Media>
                <div>
                  <Media query="(min-width: 992px)">
                    <h3>Ordering request</h3>
                  </Media>
                  <Row style={{ marginTop: "3%" }} className="align-middle">
                    <Col className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 seating-topbar-search">
                      <div className="filter-button">
                        <Filter />
                      </div>
                      {/* </Col>
                  <Col md={6}> */}
                      {/* <div className="filter-button-border-left"></div> */}
                      <div className="filter-button-search">
                        {/* <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={this.onSearchChange}
                    value={this.state.search}
                    className="amSearch"
                  /> */}
                        <Paper component="form" className="enSearch2 d-flex">
                          <IconButton type="submit" aria-label="search">
                            <SearchIcon />
                          </IconButton>
                          <InputBase
                            placeholder="Search"
                            className="w-100"
                            inputProps={{
                              "aria-label": "Search by Name or Phone Number",
                            }}
                            onChange={onSearchChange}
                            value={state.search}
                          />
                        </Paper>
                      </div>
                    </Col>
                  </Row>
                  <div className="vendor-orders-badges">
                    <span
                      className={`badge ${
                        props.selectedTabId === 1
                          ? "badge-custom-primary"
                          : "badge-custom-secondary"
                      }`}
                      onClick={() => onChangeTab(1)}
                    >
                      All
                    </span>
                    {categories.map((item, index) => (
                      <span
                        key={index}
                        className={`badge ${
                          props.selectedTabId === item._id
                            ? "badge-custom-primary"
                            : "badge-custom-secondary"
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => onChangeTab(item._id)}
                      >
                        {item.name}
                      </span>
                    ))}
                    {/* <span className="badge badge-custom-secondary">Specials</span>
                  <span className="badge badge-custom-secondary">Starters</span>
                  <span className="badge badge-custom-secondary">
                    Beverages
                  </span>
                  <span className="badge badge-custom-secondary">Pizza</span>
                  <span className="badge badge-custom-secondary">Pasta</span> */}
                  </div>
                  <div
                    className="filter-section align-middle "
                    style={{ marginTop: "3%" }}
                  >
                    <Row className="mobile-d-flex">
                      <Col
                        xs={4}
                        className="d-flex mobile-p-0 mobile-f10-500 align-items-center"
                      >
                        Only Veg &nbsp;&nbsp;
                        <Toggle
                          checked={showVeg}
                          toggleFunction={() => setShowVeg(!showVeg)}
                          height={12}
                          // toggleFunction={toggleFunction}
                        />
                      </Col>
                      <Col
                        xs={4}
                        className="d-flex mobile-p-0  mobile-f10-500 align-items-center"
                      >
                        Hide Sold Out &nbsp;&nbsp;
                        <Toggle
                          checked={hideSoldOut}
                          toggleFunction={() => setHideSoldOut(!hideSoldOut)}
                        />
                      </Col>
                      <Col xs={4}>
                        <div
                          class="btn-group"
                          role="group"
                          aria-label="Basic example"
                          align="right"
                        >
                          <button
                            type="button"
                            className={`btn grid-button-group `}
                            onClick={() => {
                              setState({ ...state, dispType: 0 });
                            }}
                            style={{ borderColor: "white" }}
                          >
                            <img
                              src={
                                state.dispType === 0
                                  ? require("../../../../assets/images/superadmin/ordericon/1-04.svg")
                                  : require("../../../../assets/images/superadmin/ordericon/squares (1).svg")
                              }
                              className="img-fluid"
                              alt="table"
                              title="table"
                            />
                          </button>
                          <button
                            type="button"
                            className={`btn grid-button-group `}
                            onClick={() => {
                              setState({ ...state, dispType: 1 });
                            }}
                            style={{ borderColor: "white" }}
                          >
                            <img
                              src={
                                state.dispType === 1
                                  ? require("../../../../assets/images/superadmin/ordericon/list (1).svg")
                                  : require("../../../../assets/images/ActionImages/image/grid.svg")
                              }
                              className="img-fluid"
                              alt="table"
                              title="table"
                            />
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                {state.dispType === 0 &&
                  data.map((data, index) => {
                    return (
                      <OrdersRequestInsideGrid
                        key={index}
                        data={data}
                        cart={state.cart}
                        decrementHandler={decrementHandler}
                        incrementHandler={incrementHandler}
                        updateCart={updateCart}
                        orderSelected={props.orderSelected}
                        showVeg={showVeg}
                        hideSoldOut={hideSoldOut}
                        search={state.search}
                        selectedTabId={props.selectedTabId}
                      />
                    );
                  })}
                {state.dispType === 1 &&
                  data.map((data, index) => {
                    return (
                      <OrdersRequestInsideList
                        key={index}
                        data={data}
                        cart={state.cart}
                        decrementHandler={decrementHandler}
                        incrementHandler={incrementHandler}
                        updateCart={updateCart}
                        orderSelected={props.orderSelected}
                        showVeg={showVeg}
                        hideSoldOut={hideSoldOut}
                        search={state.search}
                      />
                    );
                  })}
              </Container>
              <Media query="(max-width: 991px)">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    bottom: 0,
                    position: "fixed",
                    right: "35%",
                    marginBottom: "85px",
                  }}
                >
                  <div
                    className={`btn btn-md btn-${
                      props.cart_data.length > 0 ? "danger" : "secondary"
                    }`}
                    onClick={() =>
                      props.cart_data.length > 0 ? setDefault(true) : {}
                    }
                  >
                    Proceed
                  </div>
                </div>
              </Media>
            </Col>
          ) : (
            <> </>
          )}
          {(size.width < 991 && showdefault) || size.width >= 991 ? (
            <Col
              md={3}
              lg={3}
              xs={12}
              style={{ padding: "3% 0 0 0", backgroundColor: "#ffffff" }}
            >
              <EditPageAddItemRightBody
                cart={cart}
                size={size.width}
                showdefault={showdefault}
                setDefault={setDefault}
              />
            </Col>
          ) : (
            <> </>
          )}
        </Row>
      </Container>
    </React.Fragment>
  );
};

const VegNonVegItem = (
  data,
  showVeg,
  orderSelected,
  search,
  hideSoldOut,
  selectedTabId
) => {
  // console.log(data);
  let filterData = [];

  if (!showVeg) {
    filterData = data.items;
  } else if (showVeg) {
    filterData = data.items.filter((newData) => newData.veg === true);
  }

  if (hideSoldOut) {
    filterData = filterData.filter(
      (newData) => newData.availability === "AVAILABLE"
    );
  }

  const filteredArr = filterData.filter((review) => {
    return review.name.toLowerCase().includes(search.toLowerCase());
  });

  const availableTime = (cardData) => {
    const day = moment().format("dddd").toLowerCase();

    if (cardData[day]?.open  && cardData?.availability == "AVAILABLE") {
      let currentTime = "";
      (cardData[day]?.multiple_timings || []).map((time) => {
        let nowTime = moment(new Date()).format("HHmmss");
        const timeStamp = moment().unix();
        let openTimeConverted = moment(time?.opening_time).format("HHmmss");
        let closeTimeConverted = moment(time?.closing_time).format("HHmmss");
        if (
          nowTime>= openTimeConverted && nowTime<= closeTimeConverted
        )
          currentTime = `${moment(time?.opening_time).format(
            "hh:mm A"
          )}-\n${moment(time?.closing_time).format("hh:mm A")}`;
      });
      return currentTime || "-";
    }
    else if(cardData[day]?.open && cardData?.availability !== "AVAILABLE"){
      if(cardData[day]?.multiple_timings?.length > 1 ){
      let currentTime = "";
      (cardData[day]?.multiple_timings || []).map((time) => {
        let nowTime = moment(new Date()).format("HHmmss");
        const timeStamp = moment().unix();
        let openTimeConverted = moment(time?.opening_time).format("HHmmss");
        let closeTimeConverted = moment(time?.closing_time).format("HHmmss");
        if (
           nowTime<= closeTimeConverted
        )
          currentTime = `${moment(time?.opening_time).format(
            "hh:mm A"
          )}-\n${moment(time?.closing_time).format("hh:mm A")}`;
      });

      return currentTime;
    } else if (cardData[day]?.multiple_timings?.length == 1) {
      let currentTime = "";
      currentTime = `${moment(cardData[day]?.multiple_timings?.opening_time).format(
        "hh:mm A"
      )}-\n${moment(cardData[day]?.multiple_timings?.closing_time).format("hh:mm A")}`;
      return currentTime;
    }
    else{
      return "-"
    }
    }
    else {
      return "-";
    }

  };

  try {
    if (!isEmpty(filteredArr)) {
      return filteredArr.map((card, index) => (
        <Fragment key={index}>
          <Col
            md={4}
            xs={6}
            className="mobile-p-1"
            style={data?.padding && { marginTop: "3%" }}
            // style={{ marginTop: "2%" }}
            //key={index}
          >
            <Card style={{ width: "100%" }}>
              <CardActionArea>
                <CardMedia
                  style={{ height: 140 }}
                  image={
                    (card && card?.images && card?.images[0]) ||
                    NOTAVAILABLEIMAGE
                  }
                  //title={card?.name}
                  title={card?.name}
                >
                  <div
                    style={{
                      position: "relative",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      top: "2%",
                      left: "5%",
                    }}
                    class="bottom-left"
                    className="badge badge-dark"
                  >
                    <img
                      src={require("../../../../assets/images/superadmin/ordericon/star.svg")}
                      width="10px"
                      heigth="10px"
                    />
                    {card?.rating}
                  </div>
                  {card?.best && (
                    <div
                      style={{
                        position: "relative",
                        top: "80%",
                        left: "-5%",
                      }}
                      class="bottom-left"
                      className="badge badge-warning"
                    >
                      Best Selling
                    </div>
                  )}
                </CardMedia>
                <CardContent className="content-grid-inner">
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    style={{ padding: "8px" }}
                  >
                    {ITEMTYPEVEG.map((type, index) => {
                      return (
                        <React.Fragment key={index}>
                          {card?.itemType === type?.value ? (
                            <Image
                              width="15px"
                              height="15px"
                              src={type?.url}
                              alt={type?.title}
                              title={type?.title}
                              fluid
                              className="mr-2"
                            />
                          ) : null}
                        </React.Fragment>
                      );
                    })}
                    {/* <img
                    src={
                      card.veg
                        ? require("../../../../assets/images/superadmin/ordericon/veg.svg")
                        : require("../../../../assets/images/superadmin/ordericon/non veg.svg")
                    }
                    width="15px"
                    heigth="15px"
                  /> */}{" "}
                    <span
                      style={{
                        fontSize: ".95rem",
                        fontWeight: "bold",
                      }}
                    >
                      {card?.name}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    <table style={{ width: "100%" }} className="f10-400">
                      <tbody>
                        <tr>
                          <td>
                            <img
                              src={require("../../../../assets/images/superadmin/ordericon/rupees.svg")}
                              width="30px"
                            />{" "}
                          </td>
                          <td>
                            <span style={{ fontWeight: "bold" }}>
                              {card[orderSelected]?.sizes.map((item, index) => (
                                <Fragment key={index}>
                                  {item?.isDefault ? item?.price : <> </>}
                                </Fragment>
                              ))}
                            </span>
                            <br />
                            <span>Price</span>
                          </td>
                          <td
                            className="hidden-in-mobile"
                            style={{ width: "25px" }}
                          >
                            <br />
                          </td>
                          <td>
                            <img
                              src={require("../../../../assets/images/superadmin/ordericon/clock (2).svg")}
                              width="30px"
                            />{" "}
                          </td>
                          <td>
                            <span
                              style={{
                                fontWeight: "bold",
                                color: "#EE3A23",
                              }}
                            >
                              {card?.prepTime} Mins
                            </span>
                            <br />
                            <span>Preparation Time</span>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={5}>
                            <hr />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <img
                              src={require("../../../../assets/images/superadmin/ordericon/serves.svg")}
                              width="30px"
                            />{" "}
                          </td>
                          <td>
                            <span style={{ fontWeight: "bold" }}>
                              {card[orderSelected]?.sizes.map((item, index) => (
                                <Fragment key={index}>
                                  {item?.isDefault ? item?.pax : <> </>}
                                </Fragment>
                              ))}
                            </span>
                            <br />
                            <span>Serves</span>
                          </td>
                          <td
                            className="hidden-in-mobile"
                            style={{ width: "25px" }}
                          >
                            <br />
                          </td>
                          <td>
                            <img
                              src={require("../../../../assets/images/superadmin/ordericon/clock.svg")}
                              width="30px"
                            />{" "}
                          </td>
                          <td>
                            <span style={{ fontWeight: "bold" }}>
                              {/* {card?.atime} */}
                              {availableTime(card)}
                            </span>
                            <br />
                            <span>Available Time</span>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={5}>
                            <hr />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <img
                              src={require("../../../../assets/images/superadmin/ordericon/halal.svg")}
                              width="30px"
                            />{" "}
                          </td>
                          <td>
                            <span style={{ fontWeight: "bold" }}>
                              {card?.primary_food_type?.title}
                            </span>
                            <br />
                            <span>Food Type</span>
                          </td>
                          <td
                            className="hidden-in-mobile"
                            style={{ width: "25px" }}
                          >
                            <br />
                          </td>
                          <td>
                            <img
                              src={require("../../../../assets/images/superadmin/ordericon/calories.svg")}
                              width="30px"
                            />{" "}
                          </td>
                          <td>
                            <span style={{ fontWeight: "bold" }}>
                              {card[orderSelected]?.sizes.map((item, index) => (
                                <Fragment key={index}>
                                  {item?.isDefault ? item?.calories : <> </>}
                                </Fragment>
                              ))}
                            </span>
                            <br />
                            <span>Calories Count</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <AddButton
                 disabled={card?.availability !== "AVAILABLE"}
                  customizationData={card}
                  orderSelected={orderSelected}
                  categoryName={data.name}
                />
              </CardActions>
            </Card>
          </Col>
        </Fragment>
      ));
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
  }
};

const OrdersRequestInsideGrid = (props) => {
  const [show, setShow] = React.useState(!props.data.sub);
  // const [data, setData] = React.useState(props.data);

  // useEffect(() => {
  //   setData(props.data);
  // }, [props.data]);

  return (
    <React.Fragment>
      <Container fluid>
        <div
          className="body-orders-requests"
          onClick={() => {
            setShow(!show);
          }}
        >
          <h4>
            <b>{props.data?.name}</b> &nbsp;
            {!props.data?.sub && (
              <span>
                <span style={{ color: "#EE3A23" }}>
                  {/* {`${data?.data.length}`} Items */}
                  {props.data &&
                    props.data?.items &&
                    props.data?.items.length}{" "}
                  Items
                </span>
                <p
                  style={{ float: "right" }}
                  align="right"
                  // onClick={() => {
                  //   setShow(!show);
                  // }}
                >
                  {/* {show ? "hide" : "show"} */}
                  {show ? (
                    <i className="fa fa-chevron-up" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-chevron-down" aria-hidden="true"></i>
                  )}
                </p>
              </span>
            )}
          </h4>
        </div>
        {/* {data &&
          data.items &&
          data.items.map((data, index) => {
            return (
              <OrdersRequestInsideGrid
                key={index}
                data={data}
                cart={props.cart}
                decrementHandler={props.decrementHandler}
                incrementHandler={props.incrementHandler}
                updateCart={props.updateCart}
                style={{ padding: "15px" }}
              />
            );
          })} */}
        {show && (
          <div>
            <Row>
              {VegNonVegItem(
                props.data,
                props.showVeg,
                props.orderSelected,
                props.search,
                props.hideSoldOut,
                props.selectedTabId
              )}
            </Row>
          </div>
        )}
      </Container>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  cart_data: state.vendorOrdering.vendor_cart_data,
});

export default withRouter(
  connect(mapStateToProps, null)(EditPageOrderRequestBody)
);

// export default EditPageOrderRequestBody;
